import axios from "../utils/axios";

/**
 * List all collections with pagination and filtering
 * @param {Object} params - Query parameters (page, per_page, search, etc.)
 * @returns {Promise} Collections list
 */
export const getCollections = async (params) => {
    try {
        const { data } = await axios.get('/admin/collections', { params });
        return data;
    } catch (error) {
        console.error("🚀 ~ getCollections ~ error:", error);
        throw error;
    }
};

/**
 * Get a single collection by ID
 * @param {number|string} id - Collection ID
 * @returns {Promise} Collection data
 */
export const getCollectionById = async (id) => {
    try {
        const { data } = await axios.get(`/admin/collections/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ getCollectionById ~ error:", error);
        throw error;
    }
};

/**
 * Create a new collection
 * @param {Object} collectionData - Collection data
 * @returns {Promise} Created collection
 */
export const createCollection = async (collectionData) => {
    try {
        const { data } = await axios.post('/admin/collections', collectionData);
        return data;
    } catch (error) {
        console.error("🚀 ~ createCollection ~ error:", error);
        throw error;
    }
};

/**
 * Update an existing collection
 * @param {number|string} id - Collection ID
 * @param {Object|FormData} collectionData - Updated collection data
 * @returns {Promise} Updated collection
 */
export const updateCollection = async (id, collectionData) => {
    try {
        // Check if data is FormData (for file uploads like cover image)
        if (collectionData instanceof FormData) {
            collectionData.append('_method', 'PUT');
            const { data } = await axios.post(`/admin/collections/${id}`, collectionData, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            return data;
        }
        // For JSON data, use PUT directly
        const { data } = await axios.put(`/admin/collections/${id}`, collectionData);
        return data;
    } catch (error) {
        console.error("🚀 ~ updateCollection ~ error:", error);
        throw error;
    }
};

/**
 * Delete a collection
 * @param {number|string} id - Collection ID
 * @returns {Promise} Result of deletion
 */
export const deleteCollection = async (id) => {
    try {
        const { data } = await axios.delete(`/admin/collections/${id}`);
        return data;
    } catch (error) {
        console.error("🚀 ~ deleteCollection ~ error:", error);
        throw error;
    }
};

/**
 * Sync products for a collection
 * @param {number|string} id - Collection ID
 * @param {Array} product_ids - Array of product IDs to link
 * @returns {Promise} Sync result
 */
export const syncCollectionProducts = async (id, product_ids) => {
    try {
        const { data } = await axios.post(`/admin/collections/${id}/products/sync`, { product_ids });
        return data;
    } catch (error) {
        console.error("🚀 ~ syncCollectionProducts ~ error:", error);
        throw error;
    }
};
